export class CashReceipt {
    date = new Date();
}
